import BaseCustomScheme from './baseCustomScheme'

export default class SchemeDevice extends BaseCustomScheme {
  // you can extend functionality of this schema later
}
